import * as React from "react";

export class ShowAllBtn extends React.PureComponent<{ expanded: boolean, label: string, onClick() }, {}> {

    render() {

        return (
            <div className={this.props.expanded ? "rj-league-list__show-all rj-league-list__show-all--less" : "rj-league-list__show-all rj-league-list__show-all--more"} data-uat={`div-league-list-show-all-${this.props.expanded ? 'less' : 'more'}`}>
                <button className="rj-league-list__show-all-btn" onClick={this.props.onClick} data-uat="button-league-list-show-all">
                    {this.props.label}

                    <div className="rj-league-list__show-all-arrows" data-uat="div-league-list-show-all">
                        <span className="rj-league-list__show-all-arrow rj-league-list__show-all-arrow--top" data-uat="span-league-list-show-all-arrow-top"></span>
                        <span className="rj-league-list__show-all-arrow" data-uat="span-league-list-show-all-arrow"></span>
                    </div>
                </button>
            </div>
        )
    }
}